export enum ContactMethod {
  Email = 'email',
  Phone = 'phone',
  Sms = 'sms',
}

export enum Ethnicity {
  NoEthnicitySpecified = 1,
  HispanicOrLatino = 2,
  NotHispanicOrLatino = 3,
  DeclinedToSpecify = 4,
}
export enum GenderIdentity {
  Unknown = 1,
  Man = 2,
  Woman = 3,
  TransgenderManAndOrTransMasculine = 4,
  TransgenderWomanAndOrTransFeminine = 5,
  NonBinaryAndOrGenderQueerAndOrGenderFluid = 6,
  OptionNotListed = 7,
  PreferNotToSay = 8,
  TwoSpirit = 9,
}

export enum LegalGenderMarker {
  F = 'F',
  M = 'M',
  X = 'X',
  U = 'U',
}

export enum PatientGuarantorRelationship {
  Child = 'child',
  Other = 'other',
  Spouse = 'spouse',
}

export enum PatientInsurancePaymentProgram {
  Commercial = 'commercial_other',
  Medicare = 'medicare_part_b',
  Medicaid = 'medicaid',
  WorkersCompensation = 'workers_compensation',
}

export enum PatientRelationshipToInsured {
  Self = 'self',
  Child = 'child',
  Spouse = 'spouse',
  Other = 'other',
}

export enum PatientStatus {
  Active = 'active',
  Deceased = 'deceased',
  Inactive = 'inactive',
  Prospect = 'prospect',
}

export enum PatientStatusInactiveReason {
  PracticeEnded = 'practice_ended',
  LeftGoodTerms = 'left_good_terms',
  Other = 'other',
  LeftBadTerms = 'left_bad_terms',
  Unknown = 'unknown',
}

export enum PhoneType {
  Fax = 'Fax',
  Home = 'Home',
  Main = 'Main',
  Mobile = 'Cell Phone',
  Night = 'Night',
  Other = 'Other',
  Work = 'Work',
}

export enum Pronouns {
  SheHerHers = 'she_her_hers',
  HeHimHis = 'he_him_his',
  TheyThemTheirs = 'they_them_theirs',
  OptionNotListed = 'not_listed',
}

export enum Race {
  NotSpecified = 1,
  AmericanIndianOrAlaskaNative = 2,
  Asian = 3,
  BlackOrAfricanAmerican = 4,
  NativeHawaiianOrOtherPacificIslander = 5,
  White = 6,
  DeclinedToSpecify = 7,
}

/**
 * Should only be used for sex assigned at birth. Use gender identity instead for most fields,
 * especially anything patient-facing.
 */
export enum Sex {
  Male = 'M',
  Female = 'F',
  IntersexAndOrOther = 'O',
  Unknown = 'N',
}

export enum SexualOrientation {
  Unknown = 1,
  Straight = 2,
  Gay = 3,
  Bisexual = 4,
  OptionNotListed = 5,
  PreferNotToSay = 6,
  Lesbian = 7,
  Queer = 8,
  Asexual = 9,
}

export const MIN_DOB_YEAR = 1900;
export const MIN_DOB_DATE = new Date(MIN_DOB_YEAR, 0, 1);
